import { useSegments } from "api/segments";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { Condition, Parts, SegmentFEParts, SegmentTypes } from "types/segments";
import { links } from "utilities/links";
import { SegmentForm, getComponent } from "./SegmentForm";
import { useStyles } from "./SegmentForm.styles";

export const getParts = (parts: Parts[]): SegmentFEParts[] => {
  return parts.map((item) => {
    return {
      criteria: item.criteria?.map(
        (criterion: { type: string; anniversaryType?: string }) => {
          // On BE they have one type "anniversary", but to handle them on FE they must be unique (merged type with anniversaryType)
          if (criterion.type === "anniversary") {
            return criterion.anniversaryType === "birthday"
              ? {
                  ...criterion,
                  isConditionSaved: true,
                  component: getComponent("anniversary-birthday"),
                  type: "anniversary-birthday",
                }
              : {
                  ...criterion,
                  isConditionSaved: true,
                  component: getComponent("anniversary-registration"),
                  type: "anniversary-registration",
                };
          } else {
            return {
              ...criterion,
              isConditionSaved: true,
              component: getComponent(criterion.type),
            };
          }
        },
      ),
    };
  });
};

export function EditSegment() {
  const classes = useStyles();
  const { useSegmentData } = useSegments();
  const { id: segmentID } = useParams<{ id: string }>();
  const { data: segmentData } = useSegmentData(segmentID);
  const { message } = useMessage();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "segments" }),
      path: links.segmentsList,
    },
  };

  const isStaticSegment = segmentData?.parts[0]?.criteria?.some(
    (criterion: Condition) => criterion.type === "customer_csv_list",
  );

  return (
    <>
      <TopHeader
        title={`${message({ id: "editSegment" })} "${segmentData ? segmentData?.name : ""}"`}
        clearLink={links.segmentsList}
        breadcrumbs={breadcrumbs}
      />
      <div className={classes.formContainer}>
        {segmentData && (
          <SegmentForm
            initialValues={{
              type: isStaticSegment
                ? SegmentTypes.STATIC
                : SegmentTypes.DYNAMIC,
              active: segmentData.active,
              name: segmentData.name,
              parts: getParts(segmentData.parts),
              description: segmentData.description,
            }}
            isEditMode
          />
        )}
      </div>
    </>
  );
}
